"use strict";
const NOOP = () => {
};

export { NOOP };
//# sourceMappingURL=NOOP.mjs.map
